import { observable, computed, action } from "mobx";
import isUndefined from "lodash/isUndefined";
import times from "lodash/times";
import slice from "lodash/slice";
import BaseTableModel from "./BaseTableModel";
import LoadingStates from "./LoadingStates";
import size from "lodash/size";
import forEach from "lodash/forEach";
import filter from "lodash/filter";
import reverse from "lodash/reverse";
import map from "lodash/map";
import orderBy from "lodash/orderBy";
import { observableMap } from "util/mobx";

class StaticTableModel extends BaseTableModel {
    @observable data = observable([]);
    @observable loadState = LoadingStates.UI_READY;

    constructor(props) {
        super(props);
        if (!isUndefined(props.data)) {
            this.data = observable(map(props.data, row => this.createRowModel(row)));
            this.loadState = LoadingStates.DATA_LOADED;
        }
    }

    @computed
    get currentData() {
        if (this.data.length === 0) {
            return [];
        }

        return this.pagedData[this.currentPage];
    }

    @computed
    get pagedData() {
        let pagedData = {};
        const numberOfPages = Math.ceil(this.sortedData.length / this.itemsPerPage);
        times(numberOfPages, pageNumber => {
            const pageStartIndex = pageNumber * this.itemsPerPage;
            const pageEndIndex = (pageNumber + 1) * this.itemsPerPage;
            pagedData[pageNumber] = slice(this.sortedData, pageStartIndex, pageEndIndex);
        });
        return pagedData;
    }

    @computed
    get sortedData() {
        const sortDefinitions = reverse(this.sorts.slice());
        const columns = map(sortDefinitions, sort => sort.iteratee);
        const orders = map(sortDefinitions, sort => sort.descending ? "desc" : "asc");
        return orderBy(this.filteredData, map(columns, c => { return (row) => row.data.get(c); }), orders);
    }

    @computed
    get filteredData() {
        let filteredData = this.data;
        forEach(observableMap.values(this.filters), filterDefinition => {
            filteredData = filter(filteredData, rowModel => filterDefinition.func(rowModel.data));
        });
        return filteredData;
    }

    @computed
    get recordCount() {
        return this.filteredData.length;
    }

    @computed
    get pageCount() {
        return size(this.pagedData);
    }

    @action
    replaceData(data) {
        if (!isUndefined(data)) {
            this.data = observable(map(data, row => this.createRowModel(row)));
        }
    }

    @action
    pushRowData(rowData) {
        this.data.push(this.createRowModel(rowData));
    }
}

export default StaticTableModel;
